import Pusher from "pusher-js";
import { logoutUser } from "../redux/actions/authActions";
import store from "../redux/store/store";
import { PUSHER } from "../apis/api";

const authSessionPusher = (sessionId, navigate) => {
  const pusher = new Pusher(PUSHER.appKey, {
    cluster: PUSHER.appCluster,
    encrypted: true
  });
  const channel = pusher.subscribe(sessionId);
  pusher.connection.bind("disconnected", (states) => {
    // states = {previous: 'oldState', current: 'newState'}
    console.log("disconnected");
    store.dispatch(logoutUser());
  });

  pusher.connection.bind("connected", function () {
    console.log("connected");
  });

  console.log(channel);

  channel.bind("authSession", (data) => {
    if (data.message === "session logout") {
      store.dispatch(logoutUser());
    }
  });
};

export { authSessionPusher };
